{
  "name": "@deighton/shared-ui",
  "version": "22.0.26",
  "private": false,
  "exports": {
    "./css/themes/theme.css": "./css/themes/theme.css",
    "./css/styles/styles.css": "./css/styles/styles.css",
    "./package.json": {
      "default": "./package.json"
    },
    ".": {
      "types": "./types/deighton-shared-ui.d.ts",
      "default": "./fesm2022/deighton-shared-ui.mjs"
    },
    "./charts": {
      "types": "./types/deighton-shared-ui-charts.d.ts",
      "default": "./fesm2022/deighton-shared-ui-charts.mjs"
    },
    "./core": {
      "types": "./types/deighton-shared-ui-core.d.ts",
      "default": "./fesm2022/deighton-shared-ui-core.mjs"
    },
    "./data": {
      "types": "./types/deighton-shared-ui-data.d.ts",
      "default": "./fesm2022/deighton-shared-ui-data.mjs"
    },
    "./editors": {
      "types": "./types/deighton-shared-ui-editors.d.ts",
      "default": "./fesm2022/deighton-shared-ui-editors.mjs"
    },
    "./forms": {
      "types": "./types/deighton-shared-ui-forms.d.ts",
      "default": "./fesm2022/deighton-shared-ui-forms.mjs"
    },
    "./grid": {
      "types": "./types/deighton-shared-ui-grid.d.ts",
      "default": "./fesm2022/deighton-shared-ui-grid.mjs"
    },
    "./inputs": {
      "types": "./types/deighton-shared-ui-inputs.d.ts",
      "default": "./fesm2022/deighton-shared-ui-inputs.mjs"
    },
    "./layout": {
      "types": "./types/deighton-shared-ui-layout.d.ts",
      "default": "./fesm2022/deighton-shared-ui-layout.mjs"
    },
    "./mapping": {
      "types": "./types/deighton-shared-ui-mapping.d.ts",
      "default": "./fesm2022/deighton-shared-ui-mapping.mjs"
    },
    "./media": {
      "types": "./types/deighton-shared-ui-media.d.ts",
      "default": "./fesm2022/deighton-shared-ui-media.mjs"
    },
    "./reporting": {
      "types": "./types/deighton-shared-ui-reporting.d.ts",
      "default": "./fesm2022/deighton-shared-ui-reporting.mjs"
    },
    "./services": {
      "types": "./types/deighton-shared-ui-services.d.ts",
      "default": "./fesm2022/deighton-shared-ui-services.mjs"
    }
  },
  "main": "dist/bundles/shared-ui.umd.js",
  "module": "fesm2022/deighton-shared-ui.mjs",
  "typings": "types/deighton-shared-ui.d.ts",
  "dependencies": {
    "@apollo/client": "^4.3.1",
    "@egjs/hammerjs": "^2.0.0",
    "@jsverse/transloco": "~8.4.0",
    "@jsverse/utils": "~1.0.0-beta.6",
    "@mapbox/sphericalmercator": "^2.0.2",
    "@material-symbols/metadata": "~0.45.5",
    "@progress/kendo-angular-buttons": "~24.2.2",
    "@progress/kendo-angular-charts": "~24.2.2",
    "@progress/kendo-angular-common": "~24.2.2",
    "@progress/kendo-angular-conversational-ui": "24.2.2",
    "@progress/kendo-angular-dateinputs": "~24.2.2",
    "@progress/kendo-angular-dialog": "~24.2.2",
    "@progress/kendo-angular-dropdowns": "~24.2.2",
    "@progress/kendo-angular-excel-export": "~24.2.2",
    "@progress/kendo-angular-grid": "~24.2.2",
    "@progress/kendo-angular-icons": "~24.2.2",
    "@progress/kendo-angular-indicators": "~24.2.2",
    "@progress/kendo-angular-inputs": "~24.2.2",
    "@progress/kendo-angular-intl": "~24.2.2",
    "@progress/kendo-angular-l10n": "~24.2.2",
    "@progress/kendo-angular-label": "~24.2.2",
    "@progress/kendo-angular-layout": "~24.2.2",
    "@progress/kendo-angular-menu": "24.2.2",
    "@progress/kendo-angular-navigation": "~24.2.2",
    "@progress/kendo-angular-pager": "~24.2.2",
    "@progress/kendo-angular-pdf-export": "~24.2.2",
    "@progress/kendo-angular-popup": "~24.2.2",
    "@progress/kendo-angular-progressbar": "~24.2.2",
    "@progress/kendo-angular-scrollview": "~24.2.2",
    "@progress/kendo-angular-spreadsheet": "24.2.2",
    "@progress/kendo-angular-toolbar": "24.2.2",
    "@progress/kendo-angular-treeview": "~24.2.2",
    "@progress/kendo-angular-upload": "~24.2.2",
    "@progress/kendo-angular-utils": "~24.2.2",
    "@progress/kendo-common": "~1.1.1",
    "@progress/kendo-data-query": "~1.7.2",
    "@progress/kendo-drawing": "~1.25.6",
    "@progress/kendo-svg-icons": "^5.4.0",
    "@progress/kendo-theme-core": "~14.5.0",
    "@progress/kendo-theme-default": "~14.5.0",
    "@progress/kendo-theme-material": "~14.5.0",
    "@progress/kendo-theme-utils": "~14.5.0",
    "apollo-angular": "^14.1.0",
    "apollo-upload-client": "^19.0.0",
    "date-fns": "~4.4.0",
    "echarts": "~6.1.0",
    "exifr": "~7.1.3",
    "graphql": "~17.0.2",
    "localforage": "~1.10.0",
    "mapbox-gl": "~3.31.0",
    "material-symbols": "~0.45.6",
    "monaco-editor": "~0.57.0",
    "moo": "~0.5.2",
    "ngx-monaco-editor-v2": "~22.0.5",
    "ngx-pipes": "~3.2.2",
    "ngx-quill": "~31.0.1",
    "normalize-url": "~9.0.1",
    "object-hash": "~3.0.0",
    "powerbi-client": "~2.25.0",
    "powerbi-client-angular": "~6.0.3",
    "quill": "npm:quill-next@~2.2.6",
    "tslib": "^2.6.3",
    "uuid": "~14.0.2"
  },
  "peerDependencies": {
    "@angular/animations": "^22.0.0",
    "@angular/cdk": "^22.0.0",
    "@angular/common": "^22.0.0",
    "@angular/compiler": "^22.0.0",
    "@angular/core": "^22.0.0",
    "@angular/elements": "^22.0.0",
    "@angular/forms": "^22.0.0",
    "@angular/localize": "^22.0.0",
    "@angular/material": "^22.0.0",
    "@angular/platform-browser": "^22.0.0",
    "@angular/platform-browser-dynamic": "^22.0.0",
    "@angular/router": "^22.0.0",
    "@ngrx/effects": "^22.0.0",
    "@ngrx/signals": "^22.0.0",
    "@ngrx/store": "^22.0.0",
    "@ngrx/store-devtools": "^22.0.0",
    "@okta/okta-angular": "^8.0.0",
    "@okta/okta-auth-js": "^8.0.0",
    "rxjs": "^7.0.0",
    "zone.js": "^0.16.0"
  },
  "publishConfig": {
    "directory": "dist",
    "main": "dist/fesm2022/deighton-shared-ui.mjs"
  },
  "sideEffects": false,
  "type": "module"
}